enum ShiftStatus {
	Active = 90,
	Cancelled = 100,
}

export default ShiftStatus;